<template>
  <LoadingGiftIcon v-if="isLoading"></LoadingGiftIcon>

  <div class="content container-fluid" v-else>
    <div class="card col-8 mx-auto">
      <!-- Profile Cover -->
      <div class="profile-cover">
        <div class="profile-cover-img-wrapper">
          <img
            class="profile-cover-img"
            src="../../assets/img/1920x400/img1.jpg"
            alt="Image Description"
          />
        </div>
      </div>
      <!-- End Profile Cover -->

      <!-- Profile Header -->
      <div class="text-center">
        <!-- Avatar -->
        <div class="avatar avatar-xxl avatar-circle profile-cover-avatar">
          <img
            v-if="Avatar"
            class="avatar-img"
            :src="Avatar"
            alt="User Avatar"
          />
          <span
            class="avatar-status avatar-xsl-status avatar-status-success"
          ></span>
        </div>
        <!-- End Avatar -->

        <h1 class="page-header-title">
          {{ firstName + " " + lastName }}
          <i
            class="bi-patch-check-fill fs-2 text-primary"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Top endorsed"
          ></i>
        </h1>

        <div class="card-body">
          <dl class="row text-start">
            <dt class="col-sm-6 text-sm-end">Organization:</dt>
            <dd class="col-sm-6">
              {{ member.client.name }}
            </dd>

            <dt class="col-sm-6 text-sm-end">Domain:</dt>
            <dd class="col-sm-6">
              {{ member.client.domains[0] }}
            </dd>

            <dt class="col-sm-6 text-sm-end">Email:</dt>
            <dd class="col-sm-6">{{ member.email }}</dd>

            <dt class="col-sm-6 text-sm-end">Member since:</dt>
            <dd class="col-sm-6">{{ formattedDate }}</dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingGiftIcon from "../../components/ui/LoadingGiftIcon.vue";
import moment from "moment";
export default {
  name: "MemberDetails",
  components: { LoadingGiftIcon },
  data() {
    return {
      member: {},
      isLoading: true,
    };
  },
  created() {
    const memberId = this.$route.params.memberId;
    this.loadMemberInformation(memberId);
  },
  computed: {
    Avatar() {
      const url = this.User?.photo;
      if (url) {
        if (url.indexOf("/") === 0) {
          return process.env.VUE_APP_API_BASE_URL + url;
        } else {
          return url;
        }
      } else {
        return `https://api.dicebear.com/7.x/initials/svg?seed=${this.firstName}%20${this.lastName}&backgroundColor=3949ab`;
      }
    },
    User() {
      return this.$store.state.auth.user;
    },
    fullName() {
      return this.firstName + " " + this.lastName;
    },
    firstName() {
      return this.member.firstName ? " " + this.member.firstName : "";
    },
    lastName() {
      return this.member.lastName;
    },
    email() {
      return this.member.email;
    },
    company() {
      return this.member.client.name;
    },
    formattedDate() {
      const date = moment(this.member.createdAt).format("MM/DD/YYYY");
      return date;
    },
  },
  methods: {
    async loadMemberInformation(memberId) {
      /**@type {import('@boldxchange/sdk/defs').Client}*/

      const api = await this.getBoldClient();
      this.isLoading = true;

      let requestBody = {
        _id: memberId,
      };

      let selection = "client firstName lastName email createdAt";

      const queryParameters = {
        limit: 1,
        sort: "firstName",
        expand: "client",
      };

      try {
        const response = await api.listUsers(queryParameters, {
          filter: requestBody,
          selection: selection,
        });

        this.isLoading = false;
        this.member = response.data.result.records[0];
      } catch (error) {
        console.log("member did not load", error);
        this.isLoading = false;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
